import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArtigoGuiaCompleto from "../pages/artigo/cssbuy-spreadsheet-guia-completo/page";
import ArtigoComoUsar from "../pages/artigo/como-usar-cssbuy-spreadsheet/page";
import ArtigoComparacao from "../pages/artigo/comparacao-cssbuy-pandabuy-superbuy/page";
import ArtigoSeguranca from "../pages/artigo/seguranca-cssbuy-spreadsheet/page";
import ArtigoFrete from "../pages/artigo/frete-china-brasil/page";
import ArtigoAtualizado2026 from "../pages/artigo/cssbuy-spreadsheet-atualizado-2026/page";
import ArtigoVsTaobao from "../pages/artigo/cssbuy-vs-taobao-weidian/page";
import ArtigoGuiaComprar from "../pages/artigo/guia-comprar-china-brasil/page";
import ArtigoMelhoresAgentes from "../pages/artigo/melhores-agentes-compra-2026/page";
import ArtigoStreetwear from "../pages/artigo/streetwear-cssbuy-spreadsheet/page";
import ArtigosSneakers from "../pages/artigo/sneakers-cssbuy-spreadsheet/page";
import ArtigoErrosComuns from "../pages/artigo/erros-comuns-cssbuy/page";
import ArtigoEvitarTaxa from "../pages/artigo/evitar-taxa-importacao/page";
import ArtigoTabelaPronta from "../pages/artigo/tabela-cssbuy-pronta/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/artigo/cssbuy-spreadsheet-guia-completo", element: <ArtigoGuiaCompleto /> },
  { path: "/artigo/como-usar-cssbuy-spreadsheet", element: <ArtigoComoUsar /> },
  { path: "/artigo/comparacao-cssbuy-pandabuy-superbuy", element: <ArtigoComparacao /> },
  { path: "/artigo/seguranca-cssbuy-spreadsheet", element: <ArtigoSeguranca /> },
  { path: "/artigo/frete-china-brasil", element: <ArtigoFrete /> },
  { path: "/artigo/cssbuy-spreadsheet-atualizado-2026", element: <ArtigoAtualizado2026 /> },
  { path: "/artigo/cssbuy-vs-taobao-weidian", element: <ArtigoVsTaobao /> },
  { path: "/artigo/guia-comprar-china-brasil", element: <ArtigoGuiaComprar /> },
  { path: "/artigo/melhores-agentes-compra-2026", element: <ArtigoMelhoresAgentes /> },
  { path: "/artigo/streetwear-cssbuy-spreadsheet", element: <ArtigoStreetwear /> },
  { path: "/artigo/sneakers-cssbuy-spreadsheet", element: <ArtigosSneakers /> },
  { path: "/artigo/erros-comuns-cssbuy", element: <ArtigoErrosComuns /> },
  { path: "/artigo/evitar-taxa-importacao", element: <ArtigoEvitarTaxa /> },
  { path: "/artigo/tabela-cssbuy-pronta", element: <ArtigoTabelaPronta /> },
  { path: "*", element: <NotFound /> },
];

export default routes;